import { useLocation, useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";
import { BREADCRUMB_LABELS, buildBreadcrumbParentMap } from "./portalHelpers";

const PortalBreadcrumb = ({ portalBasePath }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;
  const parentMap = buildBreadcrumbParentMap(portalBasePath);

  const getLabel = (segment) => {
    if (BREADCRUMB_LABELS[segment]) return BREADCRUMB_LABELS[segment];
    return segment.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const parentEntry = Object.entries(parentMap).find(([key]) => path.startsWith(key));
  if (!parentEntry) return null;

  const parentPath = location.state?.from || parentEntry[1];
  const parentLabel = getLabel(parentPath.split("/").pop());
  const currentSegment = path.split("/").filter(Boolean).pop();

  return (
    <div className="portal-breadcrumb flex items-center gap-2">
      <button
        type="button"
        onClick={() => navigate(parentPath)}
        className="portal-breadcrumb__back"
        title={`Back to ${parentLabel}`}
      >
        <IoArrowBack size={18} />
      </button>
      <span className="portal-breadcrumb__sep" aria-hidden="true">
        /
      </span>
      <span className="portal-breadcrumb__current">{getLabel(currentSegment)}</span>
    </div>
  );
};

export default PortalBreadcrumb;
